<!--
	作者：1764635606@qq.com
	时间：2018-07-24
	描述：下拉菜单封装，支持级联
	
	props:
	   trigger:        触发方式，默认为‘click’
       title:          按钮上显示的文字，默认为‘请选择’
	   list:           内容数组
-->

<template>
    <Dropdown trigger="click" @on-click="choose" @on-visible-change="change" :placement="placement" class="bp-dropdown">
        <Button type="primary">
            <Icon type="arrow-left-b" v-if="orientation === 'left'"></Icon>
            {{title}}
            <Icon type="arrow-up-b" v-if="orientation === 'up'"></Icon>
            <Icon type="arrow-right-b" v-if="orientation === 'right'"></Icon>
            <Icon type="arrow-down-b" v-if="orientation === 'down'"></Icon>
        </Button>
        <DropdownMenu slot="list">
            <DropdownItem v-if="list.length == 0" disabled>暂无选项</DropdownItem>
            <template v-for="item in list">
                <BPDropdownCasc :list="item.children" :title="item.label" :name="item.value" v-if="item.children"></BPDropdownCasc>
                <DropdownItem :name="item.value" :key="item.value" :disabled="item.disabled" v-else>{{item.label}}</DropdownItem>
            </template>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    import {util, check} from '@/utils'
    
    export default {
        props: {
            trigger: {
                default: 'click'
            },
            title: {
                default: '请选择'
            },
            placement: {
                type: String
            },
            list: {
                type: Array,
                default () {
                    return []
                }
            },
        },
        computed: {
            orientation () {
                let result = 'down'
                if (this.placement) {
                    let str = this.placement.toString()
                    if (str.indexOf('top') !== -1) {
                        result = 'up'
                    }
                    if (str.indexOf('bottom') !== -1) {
                        result = 'down'
                    }
                    if (str.indexOf('left') !== -1) {
                        result = 'left'
                    }
                    if (str.indexOf('right') !== -1) {
                        result = 'right'
                    }
                }
                return result
            }
        },
        data () {
            return {
                result: []
            }
        },
        methods: {
            choose (res) {
                this.result.push(res)
            },
            change (res) {
                if (!res) {
                    let result = util.deepCopy(this.result)
                    this.$emit('on-change', result)
                }
            }
        }
    }
</script>

<style lang="less" scoped>
</style>